import { useQuery } from "react-query";
import { useLocation } from "react-router-dom";

import { pointInPolygon } from "../../../Global/Widgets/Map/MapComponents/Helpers/pointInPolygon";
import { sections } from "../../../Global/Widgets/Map/MapComponents/UniversitySections/geoSections";

import axiosInstance from "../../../../api/axiosInstance";
import query from "../../../../api/constants.api";
import { serializeIncident } from "../../../../api/helpers.api";
import { TIncident } from "../../../../api/types";
import { useGlobalStateContext } from "../../../../contexts/GlobalStateContext";

type TSuccess = {
    data: any;
    step: number;
    setStep: (step: number) => void;
    setShowList: (step: boolean) => void;
};

type TUseLocation = {
    state: {
        section: string;
        position: { lat: number, lng: number };
    }
}

type TProps = {
    selectedCategoryId: string;
    showList: boolean;
    step: number;
    setStep: (step: number) => void;
    setShowList: (step: boolean) => void;
};

const fetchIncidents = (selectedCategoryId: string) => {
    // UNL asked to disbale this functionality, so it changed we changed the contact_type from 'app' to 'no_app' because this returns no incident
    // To RENABLE the funcionality, just change the 'contact_type' from 'no_app' to 'app'
            
    
    const params = {
        //sysparm_fields: 'sys_id,name,number,impact,short_description,sys_updated_on,opened_at,opened_by,description,u_nova_section,location,priority,business_service,u_latitude,u_longitude,state,caller_id,comments,watch_list',
        sysparm_fields: '',
        //active: true,
        active: true,
        //sysparm_display_value: 'all',
        sysparm_display_value: '',
        //company: 'NOVA - Campus de Campolide',
        company: '',
        //business_service: selectedCategoryId,
        business_service: "",
        //contact_type: 'app',
        contact_type: '',
    };

    return axiosInstance('GET', query.path.incident, null, params, 'application/json')
}

const useFetchIncidents = ({ selectedCategoryId, showList, step, setStep, setShowList }: TProps) => {
    const { state: { section } } = useLocation() as TUseLocation;
    const { setGlobalState } = useGlobalStateContext();

    const onSelect = (data: { data: { result: TIncident[] } }) => {
        const { data: { result } } = data

        // Filter only by incidents inside selected section
        let updatedData = result?.filter((item) => {
            const { u_latitude: { value: lat }, u_longitude: { value: lng } } = item;

            if (pointInPolygon([lat, lng], sections.find(sect => sect.name === section)?.arr)) return true;
            return false;
            // return true;
        });

        return serializeIncident(updatedData);
    }

    const onSuccess = ({ data, step, setStep, setShowList }: TSuccess) => {
        setGlobalState({ id: 'selectedBusinessId', value: selectedCategoryId });

        if (data?.length !== 0) {
            // Save incidentList to global state so that we can use it later when needed (e.g. return from Detail page)
            //setGlobalState({ id: 'incidentList', value: data });
            // Display showList set to true to enable showing list when user returns from other page (such as Detail page)
            //setGlobalState({ id: 'showList', value: true }); 
            //setShowList(true)

            // UNL asked to disbale this functionality, so it changed the behaviour for setGlobalState and setShowList, as if it did not find any incidents
            // To RENABLE the funcionality, remvoe the code bellow, and remove the comments before this comment
            setGlobalState({ id: 'incidentList', value: null });
            setGlobalState({ id: 'showList', value: false });
            setShowList(false)
            setStep(step + 1);
        } else {
            setGlobalState({ id: 'incidentList', value: null });
            setGlobalState({ id: 'showList', value: false });
            setStep(step + 1);
        }
    }

    return useQuery(['getIncidents', selectedCategoryId], () => fetchIncidents(selectedCategoryId),
        {
            enabled: !!selectedCategoryId && !showList,
            refetchOnWindowFocus: false,
            select: (data) => onSelect(data),
            onSuccess: (data) => onSuccess({ data, step, setStep, setShowList }),
            onError: () => setStep(step + 1),
        }
    )
}

export default useFetchIncidents;